import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_ME_56 } from "@/lib/programData";

export default function MarrakechErg56Page() {
  return <ProgramTemplate program={PROGRAM_ME_56} variant="me" showJourneyChronology />;
}
